import { render } from "./UserData.vue?vue&type=template&id=0957b076"
import script from "./UserData.vue?vue&type=script&lang=js"
export * from "./UserData.vue?vue&type=script&lang=js"

import "./UserData.vue?vue&type=style&index=0&id=0957b076&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__